module.exports = __webpack_public_path__ + "static/media/token-24.4aa333ee.svg";